var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-item"},[_c('div',{staticClass:"slot"},[_vm._t("default")],2),_c('button',{staticClass:"remove-button",class:_vm.removing ? 'removing' : '',attrs:{"type":"button"},on:{"click":_vm.triggerRemove}},[_c('Minus',{attrs:{"size":16}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }